'use strict';/* global define:false */define('modules/ui/directives/tab/controller',['require','exports','module'],function(require,exports,module){'use strict';
controller.$inject = ["$scope"];function head(element){// jshint validthis:true
this.head=element;}// @ngInject
function controller($scope){// jshint validthis:true
this.head=head.bind($scope);this.getScope=function(){return $scope;};}module.exports=controller;});
